import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import useLogos from "../../hooks/useLogos";
import { getInfoTextService } from "../../services/infoTextService";
import "../../styles/header.css";
import "../../styles/index.css";
import HeaderMenu from "./HeaderMenu";

const Header = () => {
  const { logoCardif } = useLogos();

  const [infoApi, setInfoApi] = useState();

  useEffect(() => {
    getInfoTextService()
      .then((resp) => {
        setInfoApi(resp.InfoApi);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <div className="sticky-top d-lg-block d-none">
        <div className="container-fluid header">
          <div className="home__header">
            <div className="home__logo">
              <NavLink to={"/"}>{logoCardif}</NavLink>
            </div>
            <HeaderMenu infoApi={infoApi} />
          </div>
        </div>
      </div>

      <div className="container-fluid header d-block d-lg-none">
        <div className="home__header">
          <div className="home__logo">
            <NavLink to={"/"}>{logoCardif}</NavLink>
          </div>
          <HeaderMenu infoApi={infoApi} />
        </div>
      </div>
    </>
  );
};

export default Header;
